(function () {
  'use strict';

  const MOBILE_FACETS_TRIGGER = '[data-bst-mobile-facets-trigger]';
  const MOBILE_FACETS_CLOSE = '[data-bst-mobile-facets-close]';
  const MOBILE_SORT_TRIGGER = '[data-bst-mobile-sort]';
  const DESKTOP_SORT_TRIGGER = '[data-bst-desktop-sort]';
  const SHOW_MORE_TRIGGER = '[data-bst-collection-show-more]';

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getSectionUrl(url, sectionId) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('section_id', sectionId);
    return nextUrl.toString();
  }

  function updateProductCounts(sourceDoc) {
    const sourceCount = sourceDoc.getElementById('ProductCount');
    const targetCount = document.getElementById('ProductCount');
    const sourceDesktopCount = sourceDoc.getElementById('ProductCountDesktop');
    const targetDesktopCount = document.getElementById('ProductCountDesktop');

    if (sourceCount && targetCount) targetCount.innerHTML = sourceCount.innerHTML;
    if (sourceDesktopCount && targetDesktopCount) targetDesktopCount.innerHTML = sourceDesktopCount.innerHTML;
  }

  function updateShowMoreCount(wrap) {
    const countNode = wrap?.querySelector('[data-bst-show-more-count]');
    if (!wrap || !countNode) return;

    const loaded = wrap.dataset.bstLoadedCount;
    const total = wrap.dataset.bstTotalCount;
    if (loaded && total) {
      countNode.textContent = `${loaded}/${total}`;
    }
  }

  async function handleShowMore(link) {
    if (link.classList.contains('is-loading')) return;

    const sectionId = link.dataset.sectionId;
    const currentGrid = document.getElementById('product-grid');
    if (!sectionId || !currentGrid) return;

    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(getSectionUrl(link.href, sectionId), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error('Failed to load next page');

      const html = await response.text();
      const parsed = parseHTML(html);
      const nextGrid = parsed.getElementById('product-grid');
      if (!nextGrid) throw new Error('Missing product grid in response');

      Array.from(nextGrid.children).forEach((item) => {
        if (item.tagName === 'LI') {
          currentGrid.appendChild(item);
        }
      });

      const currentWrap = link.closest('[data-bst-show-more-wrap]');
      const nextWrap = parsed.querySelector('[data-bst-show-more-wrap]');

      if (currentWrap && nextWrap) {
        currentWrap.replaceWith(nextWrap);
        updateShowMoreCount(nextWrap);
      } else if (currentWrap) {
        currentWrap.remove();
      }

      updateProductCounts(parsed);

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(currentGrid.innerHTML);
      }
    } catch (error) {
      console.error('BST collection show more failed', error);
    } finally {
      link.classList.remove('is-loading');
      link.removeAttribute('aria-busy');
    }
  }

  function handleSort(select, hiddenSelector) {
    const gridRoot = select.closest('[data-bst-collection-grid]');
    const hiddenSort = gridRoot?.querySelector(hiddenSelector);

    if (hiddenSort) {
      hiddenSort.value = select.value;
      hiddenSort.dispatchEvent(new Event('input', { bubbles: true }));
      hiddenSort.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('sort_by', select.value);
    window.location.href = nextUrl.toString();
  }

  function getOpenMobileFacets(gridRoot) {
    return gridRoot?.querySelector('.mobile-facets__disclosure[open]');
  }

  function closeMobileFacets(gridRoot) {
    const openDrawer = getOpenMobileFacets(gridRoot);
    const summary = openDrawer?.querySelector('summary');
    if (summary) summary.click();
  }

  function hasActiveCollectionFilters() {
    const params = new URLSearchParams(window.location.search);
    const ignoredParams = new Set(['sort_by', 'page', 'section_id']);

    return Array.from(params.keys()).some((key) => !ignoredParams.has(key));
  }

  function syncDesktopFacetsClear() {
    const clearButton = document.querySelector('.bst-collection-grid__facets-clear');
    if (!clearButton) return;

    clearButton.classList.toggle('hidden', !hasActiveCollectionFilters());
  }

  function applyMacDesktopSortFont() {
    if (!navigator.userAgent.includes('Mac')) return;

    const element = document.querySelector('.bst-collection-grid__desktop-sort-input');
    if (element) {
      element.style.fontFamily = 'var(--font-fzlt-r)';
    }
  }

  document.addEventListener('click', (event) => {
    const facetsTrigger = event.target.closest(MOBILE_FACETS_TRIGGER);
    if (facetsTrigger) {
      const gridRoot = facetsTrigger.closest('[data-bst-collection-grid]');
      const summary = gridRoot?.querySelector('.mobile-facets__disclosure > summary');
      if (summary) {
        event.preventDefault();
        summary.click();
      }
      return;
    }

    const facetsClose = event.target.closest(MOBILE_FACETS_CLOSE);
    if (facetsClose) {
      event.preventDefault();
      closeMobileFacets(facetsClose.closest('[data-bst-collection-grid]'));
      return;
    }

    const openDrawer = document.querySelector('[data-bst-collection-grid] .mobile-facets__disclosure[open]');
    if (openDrawer) {
      const openGridRoot = openDrawer.closest('[data-bst-collection-grid]');
      const clickedInsideDrawer = event.target.closest('.mobile-facets__inner');
      const clickedTrigger = event.target.closest(MOBILE_FACETS_TRIGGER);

      if (!clickedInsideDrawer && !clickedTrigger) {
        closeMobileFacets(openGridRoot);
        return;
      }
    }

    const showMoreTrigger = event.target.closest(SHOW_MORE_TRIGGER);
    if (showMoreTrigger) {
      event.preventDefault();
      handleShowMore(showMoreTrigger);
    }
  });

  document.addEventListener('change', (event) => {
    const mobileSort = event.target.closest(MOBILE_SORT_TRIGGER);
    if (mobileSort) {
      handleSort(mobileSort, '#SortBy-mobile');
      return;
    }

    const desktopSort = event.target.closest(DESKTOP_SORT_TRIGGER);
    if (desktopSort) {
      handleSort(desktopSort, '#SortBy');
    }
  });

  syncDesktopFacetsClear();
  document.querySelectorAll('[data-bst-show-more-wrap]').forEach(updateShowMoreCount);
  applyMacDesktopSortFont();
})();
